export interface BaseSheet {
  id: number
  name: string
  page_count: number
  correct_image_size: number[]
}

export class Student {
  student_sheet_id: number
  student_code: string
  student_name: string
  course_code: string
  course_name: string
  campus_code: string
  campus_name: string
  class_code: string
  class_name: string
  grade: number
  kumi: string
  student_no: number
  pageItems: PageItem[]

  constructor(x: any){
    this.student_sheet_id = x.student_sheet_id;
    this.student_code = x.student_code;
    this.student_name = x.student_name;
    this.course_code = x.course_code;
    this.course_name = x.course_name;
    this.campus_code = x.campus_code;
    this.campus_name = x.campus_name;
    this.class_code = x.class_code;
    this.class_name = x.class_name;
    this.grade = x.grade;
    this.kumi = x.kumi;
    this.student_no = x.student_no;
  }
}

export class PageItem {
  page: number
  base_sheet_fields: BaseSheetField[]
  base_width: number
  base_height: number

  constructor(page: number, base_sheet_fields: any[], base_width: number, base_height: number){
    this.page = page;
    this.base_sheet_fields = base_sheet_fields.filter((x: any) => x.page == this.page).map((x: any, idx: number) => new BaseSheetField(x, idx));
    this.base_width = base_width;
    this.base_height = base_height;
  }
}

export class BaseSheetField {
  id: number
  page: number
  idx: number
  rim: number[]
  x: number
  y: number
  width: number
  height: number
  base64_canvas: string = null
  answer_texts: AnswerText[] = []
  answer_text_idx: number = 0

  constructor(x: any, idx: number){
    this.id = x.id;
    this.page = x.page;
    this.idx = idx;
    this.rim = x.rim;
    this.x = x.rim[0];
    this.y = x.rim[1];
    this.width = x.rim[2];
    this.height = x.rim[3];
    
    this.base64_canvas = x.base64_canvas;
    for(const answer_text of x.answer_texts){

      // 未入力のテキストは削除
      if(answer_text.text == null || answer_text.text.replace(/\r?\n/g, '').trim() == "" || x.width == 0 || x.height == 0){
        continue;
      }
      this.answer_texts.push(answer_text);
    }
  }
}

export class AnswerText {
  id: number = null
  base_sheet_field_id: number = null
  idx: number = null
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_text: string = null
}
